module.exports = {
      id: "list-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite.svg#list",
      toString: function () {
        return this.url;
      }
    }